/* eslint-disable camelcase */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, Form, FormikValues } from 'formik';
import * as yup from 'yup';

import Loader from 'components/Loader';
import { CountryCode } from 'components/Selects/CountryCodeSelect';
import useCompanyConfiguration from 'hooks/useCompanyConfiguration';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Country } from 'models/country';

import { Container, Header, Subheader, NextButton, ButtonsContainer } from '../../styles';

export type OTPChannel = 'whatsapp' | 'sms';

export interface TelephoneValues {
  phone: string;
  country_code: CountryCode;
}

interface Props {
  values: TelephoneValues | null;
  onSubmit: (values: TelephoneValues, channel: OTPChannel) => Promise<any>;
  countryCodes: CountryCode[];
  country: Country | null;
  loadingCountries: boolean;
  variant?: 'incorrect-number';
  loginOAuth?: () => void;
}

const Telephone = ({ values, onSubmit, countryCodes, country, loadingCountries, variant, loginOAuth }: Props) => {
  const { t } = useStoreTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isMobile = useIsMobile();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);

  const companyConfiguration = useCompanyConfiguration();

  const isIncorrectNumberVariant = variant === 'incorrect-number';

  if (loadingCountries) return <Loader />;

  const validationSchema = yup.object().shape({
    phone: yup.string().phone().required(),
    country_code: yup.object().required(),
  });

  const initialValues: TelephoneValues = {
    phone: '',
    country_code: countryCodes.find((c) => c.id === country?.id) as CountryCode,
  };

  const handleSubmit = async (formValues: TelephoneValues) => {
    setLoading(true);
    setLoading(false);
  };

  const handleOnClick = (url) => () => {
    window.location.href = url;
  };

  return (
    <Formik
      initialStatus={{ rightCheckIfIsValid: true }}
      initialValues={isIncorrectNumberVariant ? initialValues : values || initialValues}
      isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isValid, submitForm }: FormikValues) => (
        <Form>
          <Container>
            <Header>
              {t('login.login-screen.title', { name: companyConfiguration?.companyName || 'NetViajes Corporate' })}
            </Header>
            <Subheader>{t('login.login-screen.subtitle')}</Subheader>

            <ButtonsContainer>

              <NextButton key='btnNsLogin' type="button" disabled={false} hide={companyConfiguration?.loginSso?.nsLogin === false ? true : false} loading={false} onClick={loginOAuth}>
                {t('login.login-screen.log-in-rappi', {
                  name: companyConfiguration?.companyName || 'NetViajes Corporate',
                })}
              </NextButton>  
              
                {companyConfiguration?.loginSso?.sso && companyConfiguration?.loginSso?.sso.length > 0 ? (
                
                  companyConfiguration.loginSso.sso.map((sso, idx) => (
                    <NextButton background={sso.backgroundColor} alignLeft={sso.logo ? true : false} key={idx} type="button" disabled={false} loading={false} onClick={handleOnClick(sso.url)}>
                      <span>
                        {sso.logo && (<img style={{position:'absolute', marginTop:'0px'}} src={sso.logo} width='20px' height='20px' />)}
                        <span style={{position:'relative', width: '90%', textAlign: 'left', marginLeft: '14%', color: sso.textColor}}>{sso.textButton}</span>
                      </span>
                      
                    </NextButton>
                ))) : null}

            </ButtonsContainer>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default Telephone;
